import SaleElement from './sale-element';

export default SaleElement;